export default __webpack_public_path__ + "static/media/plot_card_grey.9a3622d4.png";